<template>
  <a-modal v-model="modal" title="合并领料申请" width="500px" :maskClosable="false" :closable="false">
    <a-form-model :model="formData" ref="form">
      <a-form-model-item
        label="工作中心"
        :labelCol="{ style: 'width: 120px;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px ) !important;float:left'}"
        :rules="rules"
        prop="workCenterCodeList"
      >
        <global-select
          :value.sync="formData.workCenterCodeList"
          selectType="selectAssembleMultipleSearch"
          assembleLabel
          searchParam="centerName"
          focusGet
          requestApi="/bom/workCenter/listByCombineCallRequest"
          :selectItem="{ value: 'centerCode', label: 'centerName' }"
          :setParams="{ organizationCode: organizationCodeOrigin }"
        />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="close">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex'
import { apiMergeMaterialRequisition } from '@/api/mes/workOrderManage/ticketsManageCc'

export default {
  name: 'MergePickModal',
  data() {
    return {
      modal: false,
      formData: {
        workCenterCodeList: undefined
      },
      loading: false,
      rules: [{ required: true, message: ' ', trigger: 'change' }],
      selectedRows: []
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  methods: {
    moment,
    show (list) {
      this.selectedRows = list;
      this.formData = {
        workCenterCodeList: undefined
      }
      this.modal = true
    },
    close () {
      this.modal = false;
      this.$refs.form.resetFields();
      this.$emit('close');
    },
    submit () {
      this.$refs.form.validate(valid => {
        if(valid) {
          this.loading = true;
          apiMergeMaterialRequisition({ workCenterCodes: this.formData.workCenterCodeList }).then(res => {
            if (res?.code === 200) {
              this.modal = false
              this.$message.success('操作成功!')
              this.$emit("successCall")
            } else {
              this.$message.error(res?.msg || '操作失败!')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
